import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getFleetApprovals, approveFleet, rejectFleet } from '../api/admin';

const when = (v) => (v ? new Date(v).toLocaleString() : '—');

export default function FleetApprovals() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await getFleetApprovals();
      setRows(res.data.bookings || []);
      setError('');
    } catch (e) {
      setError(e.response?.data?.error || 'Could not load fleet approvals.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const act = async (id, action, reason = '') => {
    try {
      if (action === 'approve') {
        await approveFleet(id);
        toast.success('Booking approved');
      } else {
        await rejectFleet(id, reason);
        toast.success('Booking rejected');
      }
      load();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Action failed');
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ margin: '0 0 16px', fontSize: 22, fontWeight: 800 }}>Fleet Approvals</h2>
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}
      {loading ? <p>Loading…</p> : rows.length === 0 ? <p style={{ color: '#64748b' }}>No pending fleet approvals.</p> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {rows.map((b) => {
            const v = b.vehicles || {};
            const r = b.renter || {};
            return (
              <div key={b.id} style={card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                  <div>
                    <div style={{ fontWeight: 700 }}>{[v.year, v.make, v.model].filter(Boolean).join(' ')}</div>
                    <div style={{ fontSize: 13, color: '#64748b' }}>{v.license_plate} · {when(b.start_time)} → {when(b.end_time)}</div>
                    <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Renter: {r.full_name} · {r.email}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <button
                      style={{ ...btn, background: '#0f766e', color: '#fff' }}
                      onClick={() => act(b.id, 'approve')}
                    >Approve</button>
                    <RejectButton onReject={(reason) => act(b.id, 'reject', reason)} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function RejectButton({ onReject }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  if (!open) {
    return (
      <button style={{ ...btn, background: '#ef4444', color: '#fff' }} onClick={() => setOpen(true)}>
        Reject
      </button>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <input
        style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 14, minWidth: 180 }}
        placeholder="Reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
      <button style={{ ...btn, background: '#ef4444', color: '#fff' }} onClick={() => { if (reason.trim()) { onReject(reason); setOpen(false); setReason(''); } }}>
        Confirm
      </button>
      <button style={{ ...btn, background: '#f1f5f9', color: '#0f172a' }} onClick={() => setOpen(false)}>
        Cancel
      </button>
    </div>
  );
}

const card = {
  background: '#fff',
  border: '1px solid #e2e8f0',
  borderRadius: 12,
  padding: 16,
  boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
};

const btn = {
  padding: '8px 14px',
  borderRadius: 8,
  border: 'none',
  fontWeight: 600,
  cursor: 'pointer',
  fontSize: 13,
};
